import React, { useEffect, useState, useCallback } from 'react';
import './CardPayments.scss';
import { BsInfoCircle } from 'react-icons/bs';
import { TransactionDetails, notifyDetails } from '../../types/api.types';
import { useSelector } from 'react-redux';
import { CardOptions } from './CardOptions/CardOptions';
import { CardElement } from './CardElement/CardElement';
import { Loader } from '../../pages/Loader/Loader';
import { InstallmentOptions } from './InstallmentOptions/InstallmentOptions';
import { DiscountOptions } from './DiscountOptions/DiscountOptions';

interface CardPaymentsProps {
  onStepChange?: (step: string, data?: any) => void;
  onBackNavigation?: () => boolean;
}

export const CardPayments = ({
  onStepChange,
  onBackNavigation,
}: CardPaymentsProps) => {
  const is_s = false;
  const paymentDetails: TransactionDetails = useSelector(
    (state: any) => state.payment
  );
  const successDetail: notifyDetails = useSelector(
    (state: any) => state.notify
  );
  const [formData, setFormData] = useState({
    actionUrl: '',
    creq: '',
  });

  // Helper function to check if a provider key exists in both old and new formats
  const hasProviderKey = (keyToCheck: string): boolean => {
    if (
      !paymentDetails.data.provider_keys ||
      !Array.isArray(paymentDetails.data.provider_keys)
    ) {
      return false;
    }

    // Handle new format (array of objects)
    if (
      paymentDetails.data.provider_keys.length > 0 &&
      typeof paymentDetails.data.provider_keys[0] === 'object'
    ) {
      const providerKeys = paymentDetails.data.provider_keys as Array<{
        id: number;
        key: string;
      }>;
      return providerKeys.some((provider) => provider.key === keyToCheck);
    }

    // Handle old format (array of strings)
    const providerKeys = paymentDetails.data.provider_keys as Array<string>;
    return providerKeys.includes(keyToCheck);
  };

  const handleResponse = useCallback((data: any) => {
    if (data.status == 1000) {
      setFormData({
        actionUrl: data.data.acs_url,
        creq: data.data.acs_creq,
      });
    }
  }, []);

  useEffect(() => {
    if (formData.actionUrl) {
      const form = document.createElement('form');
      form.setAttribute('method', 'POST');
      form.setAttribute('action', formData.actionUrl);
      form.setAttribute('target', 'paymentIframe');

      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'creq');
      input.setAttribute('value', formData.creq);

      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    }
  }, [formData]);

  return (
    <div>
      {false && (
        <div className="ms-3 me-3 recurring-box">
          <div className="d-flex recurring-header pb-2">
            <div className="pe-2">
              <BsInfoCircle />
            </div>
            <div>Card recurring payment</div>
          </div>
          <div className="recurring-desc">
            Authentication for the above-mentioned payments was supposed to come
            into effect from April 1, 2024.
          </div>
        </div>
      )}

      {!formData.actionUrl &&
        !hasProviderKey('CYBERSOURCE') &&
        !hasProviderKey('CYBERSOURCE-USD') &&
        !hasProviderKey('AMEX') &&
        !hasProviderKey('AMEX-USD') && (
          <div>
            {paymentDetails.data.is_eligible_for_installment ? (
              <InstallmentOptions
                details={paymentDetails}
                response={handleResponse}
                onStepChange={onStepChange}
                onBackNavigation={onBackNavigation}
              />
            ) : paymentDetails.data.is_eligible_for_discount ? (
              <DiscountOptions
                details={paymentDetails}
                response={handleResponse}
                onStepChange={onStepChange}
                onBackNavigation={onBackNavigation}
              />
            ) : (
              <CardElement response={handleResponse} />
            )}
          </div>
        )}

      {!formData.actionUrl &&
        (hasProviderKey('CYBERSOURCE') ||
          hasProviderKey('CYBERSOURCE-USD') ||
          hasProviderKey('AMEX') ||
          hasProviderKey('AMEX-USD')) && (
          <div className="ps-3 pe-3">
            {paymentDetails.data.is_eligible_for_installment ? (
              <InstallmentOptions
                details={paymentDetails}
                response={handleResponse}
                onStepChange={onStepChange}
                onBackNavigation={onBackNavigation}
              />
            ) : paymentDetails.data.is_eligible_for_discount ? (
              <DiscountOptions
                details={paymentDetails}
                response={handleResponse}
                onStepChange={onStepChange}
                onBackNavigation={onBackNavigation}
              />
            ) : (
              <CardOptions details={paymentDetails} response={handleResponse} />
            )}
          </div>
        )}

      {formData.actionUrl && (
        <iframe
          name="paymentIframe"
          style={{ width: '100%', height: '55vh', border: 'none' }}
        />
      )}

      {successDetail.is_loading && <Loader />}
    </div>
  );
};
